import PlazoFijoRepository from '@/services/PlazoFijoRepository'

export default {
  namespaced: true,
  state: {
    entidad: null,
    listaDetalle: [],
  },
  mutations: {
    setDetalle(state, plazoFijo) {
      state.entidad = plazoFijo.entidad
      state.listaDetalle = plazoFijo.listaDetalle.map((plazoFijo,index) => {
        if (plazoFijo.importe < 0) {
          plazoFijo.importeDebito = plazoFijo.importe
          plazoFijo.importeCredito = null
        } else {
          plazoFijo.importeDebito = null
          plazoFijo.importeCredito = plazoFijo.importe
        }

        if(plazoFijo.procesado === 1){
          plazoFijo.descripcionProcesado = 'Procesado'
        }else {
          plazoFijo.descripcionProcesado = 'Pendiente'
        }
        plazoFijo.id = index

        return plazoFijo
      })
    },
  },
  actions: {
    async fetchDetalle({ commit}, [idPlazoFijo]) {
      let plazoFijo = await PlazoFijoRepository.detalle(idPlazoFijo)
      commit('setDetalle', plazoFijo)
    },
  }
}
